module.exports = __webpack_public_path__ + "static/media/pres26.0d426ebc.png";